import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useViewTagStyles = makeStyles({
  attachmentList: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
  },
});
